import React, { useEffect,useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {AppBar,Toolbar,Typography,IconButton} from '@material-ui/core';
import CList from './CList';
import NewC from './NewC';
import Comments from './Comments';
import SignIn from './SignIn';
import axios from 'axios';
import AllCmts from './AllCmts';
import PersonAddRoundedIcon from '@material-ui/icons/PersonAddRounded';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import CommentIcon from '@material-ui/icons/Comment';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import SortIcon from '@material-ui/icons/Sort';
import { version } from 'moment';
import SyncIcon from '@material-ui/icons/Sync';
import Swal from 'sweetalert2'
import {useParams} from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    marginTop:25,
    backgroundColor: theme.palette.background.paper,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    height:50,
    alignItems:'flex-start',
    justifyContent:'center',
   [theme.breakpoints.up('sm')]: {
   
   position:'fixed',
   left:0
   },
   '@global': {
    '*:focus': {
      outline: ' none !important'
    },
  },
 },
 top: {
  color: 'red',
  animationDuration: '550ms',
  position: 'absolute',
  left: '40vw',
  top:'40vh'
},
circle: {
  strokeLinecap: 'round',
},
}));

export default function FollowHome(props) {
  const classes = useStyles();
  var udataa=JSON.parse(localStorage.getItem('Data1'));
  var usinfo=JSON.parse(localStorage.getItem('UserInfo1'));
  const [isAddC, setIsAdd] = React.useState(false);
  const [IsAllC,setAllC]=React.useState(false);
  const [data, setData] = React.useState(udataa!=undefined?udataa:[]);

  const [isCmt, setIsCmt] = React.useState(false);
  const [isHome, setIsHome] = React.useState(false);
  const [isSign, setIsSing] = React.useState(false);
  const [cmaster, setCmaster] = React.useState(udataa!=undefined?udataa[0].cmaster:[]);
  const [fcomments, setFcomments] = React.useState(udataa!=undefined?udataa[0].fcomments:[]);
  const [UserInfo, setUserInfo] = React.useState(usinfo!=undefined?usinfo:[]);
  const [cselected, setCsel] = React.useState([]);
  const [cselected1, setCsel1] = React.useState([]);

  const [selected, setSel] = React.useState([]);
  const [isLogin,setLogin]=useState(false);
  const [loader,setLoader]=useState(false);

  const {sid}=useParams();

  //const [udata,setUdata]=useState(JSON.parse(localStorage.getItem('data'))); 
  console.log(udataa)
  var sortJsonArray = require('sort-json-array');

const IsComment=(v)=>{
  // setIsCmt(true);
  // setIsAdd(false);
  // setAllC(false);
  // setIsHome(false);
  setCsel(v);
 
}
const IsComment1=(v)=>{
  setIsAdd(false);setIsCmt(false);setIsHome(true);setSel([]);setSel([]);
  setAllC(false);localStorage.setItem('isAllC1',false);localStorage.setItem('isHome1',true);
  localStorage.setItem('isAdd1',false)
  setCsel(v);
 
}
// const v=useDispatch();
const Back=()=>{
  setIsCmt(false);
  setIsAdd(false);
  setAllC(false);
  setIsHome(true);
  localStorage.setItem('isHome1',true);
  // v({type:'Add'});
}
// const Signin=()=>{
//   setLogin(true);
// }
const Sync=()=>{
      setLoader(true)
     axios.post("https://topschool.prisms.in/rest/index.php/user_list.json?",{['fun_name']:"client_followup_getinfo",['sid']:props.match.params.sid,['topschool']:1}).then((res)=>{
    console.log(res);
    setCmaster(res.data.client_master);
    setFcomments(res.data.fcomment);
    var v =[{cmaster:res.data.client_master,fcomments:res.data.fcomment}]
    localStorage.setItem("Data1",JSON.stringify(v));
    setLoader(false)
})
    
}
// const CmtClicked=(v)=>{
 
// }
const Send=(vtype,time,date,pmet,interest,demo,comment)=>{
  var arr=[];
  
  if(comment !=null && comment != '' &&vtype!=null && time!=null && date!=null && pmet!=null){
   
    if(UserInfo!=undefined && UserInfo!=null){
    var us=UserInfo.user_master[0].userid;
    var nm=UserInfo.user_master[0].username;
    console.log(us)
    console.log(nm)
    console.log(cselected.cid)
    //}
    // if(us!=undefined && us!=null && nm!=undefined && nm !=null ){
      
  axios.post('https://topschool.prisms.in/rest/index.php/user_list.json?',{['fun_name']:"client_followup_insert_comment",['sid']:props.match.params.sid,['uid']:us,['name']:nm,['cid']:cselected.cid,['comment']:comment,['visit_type']:vtype,
  ['time']:time,['date']:date,['person_met']:pmet,['success_probablity']:interest,['product_demo']:demo,['topschool']:1}).then((res)=>{
    //setCmaster(res.data.client_master);
    // var fc=sortJsonArray(res.data.fcomment, 'id','des')
   // setFcomments(fc);
   var v =[{cmaster:cmaster,fcomments:res.data.fcomment}]

     setFcomments(res.data.fcomment);
     setData(v);
     localStorage.setItem("Data1",JSON.stringify(v));
     
  })
}
}
}
useEffect(()=>{    
  var usinfo=JSON.parse(localStorage.getItem('UserInfo1'));
  if(usinfo!=null && usinfo!='' && usinfo!=[] && usinfo!=undefined){
    if(usinfo.user_master!=null && usinfo.user_master!=undefined && usinfo.user_master!=[]){
  axios.post('https://topschool.prisms.in/rest/index.php/user_list.json?',
  {['fun_name']:"client_followup_auth",['sid']:sid,['email']:usinfo.user_master[0].email,['pass']:usinfo.user_master[0].password,['topschool']:1}).then((res)=>{
    // console.log(res);
    if(res.data.user_master.length>0){
    if(res.data.user_master[0].username==usinfo.user_master[0].username){
      console.log('success')
    }
  }else{
    setLogin(false);setIsAdd(false);setIsHome(false);setAllC(false);setAllC(false);localStorage.setItem('isAllC1',false);localStorage.removeItem('isHome1');localStorage.removeItem('isAdd1');localStorage.removeItem('isLoginC1');
    localStorage.removeItem('isAllC1');localStorage.removeItem('Data1');localStorage.removeItem('UserInfo1');
    window.location.reload();
  }

  })
}
}else{
  setLogin(false);setIsAdd(false);setIsHome(false);setAllC(false);setAllC(false);localStorage.setItem('isAllC1',false);localStorage.removeItem('isHome1');localStorage.removeItem('isAdd1');localStorage.removeItem('isLoginC1');
  localStorage.removeItem('isAllC1');localStorage.removeItem('Data1');localStorage.removeItem('UserInfo1');
}
},[])
const Sign=(e,p)=>{
  if(e !=null && p != null &&e !=undefined && p != undefined  ){
      axios.post('https://topschool.prisms.in/rest/index.php/user_list.json?',{['fun_name']:"client_followup_auth",['sid']:props.match.params.sid,['email']:e,['pass']:p,['topschool']:1}).then((res)=>{
      // console.log(res);
         setUserInfo(res.data);
         localStorage.setItem("UserInfo1",JSON.stringify(res.data));
         if(res.data.user_master.length==1){
          axios.post("https://topschool.prisms.in/rest/index.php/user_list.json?",{['fun_name']:"client_followup_getinfo",['sid']:props.match.params.sid,['topschool']:1}).then((resp)=>{
            //console.log(res);
            var v =[{cmaster:resp.data.client_master,fcomments:resp.data.fcomment}]
          setData(v)
            setCmaster(resp.data.client_master);
            
            //localStorage.setItem("cmaster",JSON.stringify(resp.data.client_master));
           // var fc=sortJsonArray(res.data.fcomment, 'id','des')
            setFcomments(resp.data.fcomment);
            localStorage.setItem("Data1",JSON.stringify(v));
        })
         setLogin(true);
         localStorage.setItem("isLoginC1",true);
         localStorage.setItem("isHome1",true);
         setIsHome(true)
         }
         else{
           window.alert("Wrong email or password");
         }
      })
     
    }else{
      window.alert("Enter email and password");
    }
}
const SubmitNewC=(fm)=>{

  if(fm !=null ){
  if(fm.get(['school_name'])!=null && fm.get(['strength'])!=null && fm.get(['interest_level'])!=null){
   axios.post('https://topschool.prisms.in/rest/index.php/user_list.json?',fm).then((res)=>{
   
   setCmaster(res.data.client_master);
   var v =[{cmaster:res.data.client_master,fcomments:fcomments}]
   setData(v)
   
   localStorage.setItem("Data1",JSON.stringify(v));
    window.alert('success');
  })
}
else{
Swal.fire('Warning.','Some data is missing','warning')
}
}
}

// console.log("redux->");

  return(
    <>
    {isLogin || JSON.parse(localStorage.getItem('isLoginC1'))==true?<AppBar position="fixed" className={classes.appBar}>
        <Toolbar className={classes.tool}>
        
         {isHome||JSON.parse(localStorage.getItem('isHome1'))==true ?<><Typography className={classes.title} variant="h6" noWrap>
         Client Followup
          </Typography>
          <IconButton style={{position:'fixed',right:150}} onClick={()=>Sync()}>
          <SyncIcon style={{color:'white'}} fontSize='large' />
          </IconButton>
          <IconButton style={{position:'fixed',right:100}} onClick={()=>{setIsAdd(false);setIsHome(false); setAllC(true);localStorage.setItem('isAllC1',true);localStorage.setItem('isHome1',false);localStorage.setItem('isAdd1',false);}}>
          <CommentIcon style={{color:'white'}} fontSize='large' />
          </IconButton>
          <IconButton style={{position:'fixed',right:55}} onClick={()=>{setIsAdd(true);setIsHome(false);setAllC(false);setAllC(false);localStorage.setItem('isAllC1',false);localStorage.setItem('isHome1',false);localStorage.setItem('isAdd1',true);}}>
          <PersonAddRoundedIcon style={{color:'white'}} fontSize='large' />
          </IconButton>
          <IconButton style={{position:'fixed',right:5}} onClick={()=>{setLogin(false);setIsAdd(false);setIsHome(false);setAllC(false);setAllC(false);localStorage.setItem('isAllC1',false);localStorage.removeItem('isHome1');localStorage.removeItem('isAdd1');localStorage.removeItem('isLoginC1');localStorage.removeItem('isAllC1');localStorage.removeItem('Data1');localStorage.removeItem('UserInfo1'); window.location.reload();}}>
          <ExitToAppIcon style={{color:'white'}} fontSize='large' />
          </IconButton>
          </>: isAddC || JSON.parse(localStorage.getItem('isAdd1'))==true?
          <>
          <Typography style={{position:'fixed',left:70}} variant="h6" noWrap>
          Add New Client
           </Typography>
           <IconButton style={{position:'fixed',left:2}} onClick={()=>{setIsAdd(false);setIsCmt(false);setIsHome(true);setAllC(false);setCsel([])}}>
          <KeyboardBackspaceIcon style={{color:'white'}} fontSize='large' />
          </IconButton>
           
           </>:IsAllC || JSON.parse(localStorage.getItem('isAllC1'))==true?<>
           <Typography style={{position:'fixed',left:70}} variant="h6" noWrap>
          All Comments
           </Typography>
           <IconButton style={{position:'fixed',left:2}} onClick={()=>{setIsAdd(false);setIsCmt(false);setIsHome(true);setSel([]);setSel([]);setAllC(false);localStorage.setItem('isAllC1',false);localStorage.setItem('isHome1',true);localStorage.setItem('isAdd1',false)}}>
          <KeyboardBackspaceIcon style={{color:'white'}} fontSize='large' />
          </IconButton>
           </>:null
          }
          
          <div className={classes.grow} />
        </Toolbar>
        {loader?<CircularProgress
       variant="indeterminate"
       disableShrink
       className={classes.top}
       classes={{
         circle: classes.circle,
       }}
       size={40}
       thickness={4}
       {...props}
     />:null}
      </AppBar>:null}
     
      {isLogin || JSON.parse(localStorage.getItem('isLoginC1'))==true ?<main style={{marginTop:50}}>
      {isHome ||JSON.parse(localStorage.getItem('isHome1'))==true ?
      <CList isC={IsComment} cm={cmaster} isBack={Back} send={Send} all={cselected} usrinfo={UserInfo} cms={cselected} cmt={fcomments} Data={data}/>
     : isAddC || JSON.parse(localStorage.getItem('isAdd1'))==true?<NewC isBack={Back} submit={SubmitNewC}/>
     :IsAllC || JSON.parse(localStorage.getItem('isAllC1'))==true?<AllCmts cmt={fcomments} Data={data} userinfo={UserInfo} cm={cmaster} isClicked={IsComment1}/>:null}
     </main>:<SignIn sign={Sign} />}
    </>
  );
}
